import React, { FC } from 'react';
import styles from './HorizontalDivider.module.sass';

export const HorizontalDivider : FC<React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = ({className, ...props}) => {
  return <div {...props} className={`${styles.divider} ${className ?? ""}`}>{props.children}</div>
}
